<navigation [detailData]="{ title: '', status: 'active' }"></navigation>

<loader></loader>

<div class="container">
  <footer></footer>
</div>
